
import * as filterHeaderTypes from '../webcommon/header/filterheader/propTypes';
import { lastWorkingDay } from '../common/helpermethods/HelperMethods';

export const dailyFileColumns = [
    {   
        Header: 'Id',
        id : 'id'
    }, 
    {   
        Header: 'FileName',
        id : 'fileName'
    },
    {   
        Header: 'RunDate',
        id : 'runDate'
    },
    {
        Header: 'Status',
        id: 'status'
    },
    {   
        Header: 'DateCreated',
        id : 'createdAt'
    }
]

export const incomingFileDataConst = [
    {
        id: 1,
        runDate: null,
        fileName: '',
        fileNameServer:'',
        sent: 'No'
    }
]
export const columnsGrid3 = [
    {
        id: 'checkbox',
        visible: true
    },
    {   
        Header: 'ReportId',
        id : 'id'
    }, 
    {   
        Header: 'FileName',
        id : 'fileName'
    },
    {   
        Header: 'RunDate',
        id : 'runDate'
    },
    {   
        Header: 'DateCreated',
        id : 'createdAt'
    }
]
export const columnsGrid2 = [
    {
        Header: 'RunDate Selected',
        id: 'runDate'
    },
    {
        Header: 'Local File Name',
        id: 'fileName'
    },
    {
        Header: 'Server File Name',
        id: 'fileNameServer'
    },
    {
        Header: 'Sent',
        id : 'sent'
    }
]

export const columnsFilePreview = [
    {
        Header: 'Id',
        id: 'id'
    },
    {
        Header: 'Contract',
        id: 'contract'
    },    
    {
        Header: 'IM per Lot',
        id: 'imPerLot'
    },
    {
        Header: 'Currency',
        id : 'currency'
    }
]
export const columnsGrid1 = [
    {   
        Header: 'FileId',
        id : 'fileId'
    }, 
    {   
        Header: 'FileName',
        id : 'fileName'
    },
    {
        Header: 'RunDate',
        id: 'rundate'
    },
    {
        Header: 'Status',
        id: 'status'
    },
    {   
        Header: 'DateCreated',
        id : 'createdAt'
    }    
]  
export const filterDefinitions = [
    {
        id: 'runDate',
        title: 'Date',
        type: filterHeaderTypes.filterTypes.date,
        defaultValue: { from: lastWorkingDay(), to: null, today: false },
        availableValues: undefined,
        availableValuesLocation: undefined,
        server: true,
        fromOnly: true,
        singleDay: true,
        hideAllButton: true,
        hideToday: true
    }
]
export const defaultFilters = [
    {
        value: {
            from: lastWorkingDay(),
            to: lastWorkingDay(),
            today: false
        },
        definition: filterDefinitions.find(def => def.id === 'runDate')
    }
]